export default __webpack_public_path__ + "static/media/benefit_1.da65bdd1.png";